let quickShopRequestController = null;

function getQuickshopOverlay() {
  let overlay = document.querySelector('.overlay');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.classList.add('overlay');
    overlay.addEventListener('click', closeVisibleQuickshopModal);
    document.body.appendChild(overlay);
  }

  return overlay;
}

function closeVisibleQuickshopModal() {
  const activeModal = document.querySelector('.quickshop.modal:not(.hidden)');

  if (activeModal) {
    activeModal.classList.add('hidden');
    activeModal.setAttribute('inert', '');
  }

  document.querySelectorAll('.overlay').forEach((overlay) => overlay.remove());
  document.documentElement.style.overflowY = 'unset';
}

function openQuickshopModal(modal) {
  if (!modal) return;

  closeVisibleQuickshopModal();

  getQuickshopOverlay();
  document.documentElement.style.overflowY = 'hidden';
  modal.classList.remove('hidden');
  modal.removeAttribute('inert');
  modal.querySelectorAll('input[type="radio"][checked]').forEach((radio) => {
    if (radio.nextElementSibling) {
      radio.nextElementSibling.click();
    }
  });
}

function getQuickshopModalContainer(trigger) {
  const host = trigger.closest('section, rebuy-featured, [data-quickshop-scope]');
  const scopedContainer = host ? host.querySelector('[data-quickshop-modal-container]') : null;

  return scopedContainer || document.querySelector('[data-quickshop-modal-container]');
}

async function renderQuickshopModal(trigger) {
  const productHandle = trigger.dataset.productHandle;
  const modalId = trigger.dataset.id;
  const container = getQuickshopModalContainer(trigger);

  if (!productHandle || !modalId || !container) return null;

  const renderSectionId = container.dataset.quickshopRenderSectionId || 'quick-shop-modal-render';
  const variantsDisplay = container.dataset.variantsDisplay || '';

  if (quickShopRequestController) {
    quickShopRequestController.abort();
  }

  quickShopRequestController = new AbortController();

  const params = new URLSearchParams({
    section_id: renderSectionId
  });

  if (variantsDisplay) {
    params.set('variants_display', variantsDisplay);
  }

  const requestUrl = `/products/${productHandle}?${params.toString()}`;
  const response = await fetch(requestUrl, { signal: quickShopRequestController.signal });
  if (!response.ok) return null;

  const html = await response.text();
  const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
  const renderedModal = parsedHtml.querySelector('.quickshop.modal');

  if (!renderedModal) return null;

  renderedModal.dataset.prodid = modalId;
  container.innerHTML = '';
  container.appendChild(renderedModal);

  return renderedModal;
}

async function openQuickshopFromTrigger(trigger) {
  if (!trigger) return;

  const modalId = trigger.dataset.id;
  if (!modalId) return;

  const existingModal = document.querySelector(`.modal.quickshop[data-prodid="${modalId}"]`);

  if (existingModal) {
    openQuickshopModal(existingModal);
    return;
  }

  try {
    const renderedModal = await renderQuickshopModal(trigger);
    openQuickshopModal(renderedModal);
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('Error rendering quick shop modal:', error);
    }
  }
}

async function addQuickshopItemToCart(modal, submitButton) {
  const error = modal.querySelector('.product-form__error-message-wrapper');
  const errorMessage = modal.querySelector('.product-form__error-message');
  const productTitle = modal.querySelector('.product__title');
  const checkedOption = modal.querySelector('.product-form__input input:checked');
  const cartNotification = document.querySelector('cart-notification');
  const sellingPlanID = submitButton.getAttribute('data-selling-plan-id');

  if (!productTitle || !productTitle.dataset.handle) return;

  const productHandle = productTitle.dataset.handle.toLowerCase().split(' ').join('-');
  const productResponse = await fetch(`/products/${productHandle}.js`);
  const product = await productResponse.json();
  const productVariants = product.variants || [];

  let quantity = parseInt(modal.querySelector('.quantity__input')?.value || '1', 10);
  if (Number.isNaN(quantity) || quantity < 1) {
    quantity = 1;
  }

  let variantId = '';
  let availability = false;

  productVariants.forEach((variant) => {
    if (checkedOption) {
      if (variant.title === checkedOption.value) {
        variantId = variant.id;
        availability = variant.available;
      }
    } else if (product.variants && product.variants[0]) {
      variantId = product.variants[0].id;
      availability = product.variants[0].available;
    }
  });

  if (!availability || !variantId) {
    if (error && errorMessage) {
      error.classList.remove('hidden');
      errorMessage.innerText = 'The product is sold out';
    }

    return;
  }

  if (error) {
    error.classList.add('hidden');
  }

  const bodyConfig = {
    items: [{
      id: variantId,
      quantity,
      ...(sellingPlanID ? { selling_plan: sellingPlanID } : {})
    }]
  };

  const addToCartResponse = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyConfig)
  });

  if (!addToCartResponse.ok) {
    const errorData = await addToCartResponse.json();
    throw new Error(errorData.message || errorData.description || 'Failed to add item to cart');
  }

  closeVisibleQuickshopModal();

  if (cartNotification) {
    cartNotification.productJustAddedToCartByQuickAdd();
  }
}

function quickShopModalFunction() {
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.quick__shop-btn');
    if (trigger) {
      event.preventDefault();
      await openQuickshopFromTrigger(trigger);
      return;
    }

    const closeButton = event.target.closest('.quickshop .close__btn');
    if (closeButton) {
      event.preventDefault();
      closeVisibleQuickshopModal();
      return;
    }

    const submitButton = event.target.closest('.quickshop .product-form__buttons button');
    if (!submitButton) return;

    const modal = submitButton.closest('.quickshop.modal');
    if (!modal) return;

    event.preventDefault();

    try {
      await addQuickshopItemToCart(modal, submitButton);
    } catch (error) {
      const errorWrapper = modal.querySelector('.product-form__error-message-wrapper');
      const errorText = modal.querySelector('.product-form__error-message');

      if (errorWrapper && errorText) {
        errorWrapper.classList.remove('hidden');
        errorText.innerText = error.message || 'An error occurred while adding the item to cart';
      }

      console.error('Error:', error);
    }
  });
}

function blurBadges() {
  const buttons = document.querySelectorAll('.quick__shop-btn');
  buttons.forEach((btn) => {
    btn.addEventListener('mouseenter', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.add('blur');
    });
    btn.addEventListener('mouseleave', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.remove('blur');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  quickShopModalFunction();
  // blurBadges();
});
